import { useState } from 'react'
import { Box, Text } from '@chakra-ui/react'
import { DataList, DataTable } from '@minetrace/ui'
import { brand, themeColors } from '../../theme'
import { syncService } from '../../api/services'
import type { RecpoRecord } from '../../api/services/sync.service'
import { usePagedRequest } from '../../hooks'
import SyncPageLayout from './SyncPageLayout'
import { useT } from '../../i18n'

export default function RecpoPage() {
  const colors = themeColors
  const { t } = useT()
  const [search, setSearch] = useState('')

  const recpo = usePagedRequest(syncService.getRecpo, {
    params: { search: search.trim() || undefined },
    pageSize: 25,
  })

  return (
    <SyncPageLayout
      title={t('sync.recpo.title')}
      subtitle={t('sync.recpo.subtitle')}
      syncType="Recpo"
      onRefresh={() => recpo.refresh()}
    >
      <DataList<RecpoRecord>
        searchValue={search}
        onSearchChange={setSearch}
        searchPlaceholder={t('sync.searchPlaceholder')}
        page={recpo.page}
        totalPages={recpo.totalPages}
        onPageChange={recpo.setPage}
        totalCount={recpo.totalCount}
        entityName="registros RECPO"
        pageSize={recpo.pageSize}
        onPageSizeChange={recpo.setPageSize}
        brandColor={brand.primary}
        headers={[
          t('sync.recpo.headers.ruc'),
          t('sync.recpo.headers.code'),
          t('sync.recpo.headers.resourceDate'),
          t('sync.recpo.headers.condition'),
          t('sync.recpo.headers.situation'),
        ]}
        data={recpo.items}
        loading={recpo.isFetching}
        error={recpo.error}
        emptyMessage={t('sync.recpo.emptyMessage')}
        loadingMessage={t('sync.recpo.loadingMessage')}
        colors={colors}
        keyExtractor={(r) => r.id}
        renderRow={(r) => (
          <>
            <DataTable.Cell>
              <Text fontFamily="monospace" fontSize="sm" color={colors.text}>{r.ruc}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.recpoCode}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.resourceDate ?? '-'}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Text fontSize="sm" color={colors.text}>{r.condition ?? '-'}</Text>
            </DataTable.Cell>
            <DataTable.Cell>
              <Box
                display="inline-block" px={2} py={0.5} borderRadius="md"
                fontSize="10px" fontWeight="bold" textTransform="uppercase"
                bg={r.situation === 'Completo' ? 'rgba(42, 138, 135, 0.2)' : 'rgba(212, 154, 42, 0.2)'}
                color={r.situation === 'Completo' ? '#2a8a87' : '#d49a2a'}
              >
                {r.situation ?? '-'}
              </Box>
            </DataTable.Cell>
          </>
        )}
      />
    </SyncPageLayout>
  )
}
